import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-e111599a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "word",
  "aria-hidden": "true"
}, "connectera", -1))

import ConnecteraMark from "./ConnecteraMark.vue";
// defineProps and withDefaults are compiler macros; this project's ESLint config predates them.
// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ConnecteraLogo',
  props: {
    dark: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(['connectera-logo', { 'on-light': !_ctx.dark }]),
    role: "img",
    "aria-label": "Connectera"
  }, [
    _createVNode(ConnecteraMark, {
      light: !_ctx.dark,
      class: "mark",
      "aria-hidden": "true"
    }, null, 8, ["light"]),
    _hoisted_1
  ], 2))
}
}

})